<template>
    <ValidationObserver ref="observer">
        <div>
            <b-card>
                <b-row class="my-4">
                    <b-col cols="12" md="6" class="mb-3 mb-md-0">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, validate }"
                            name="Location"
                        >
                            <GmapAutocomplete
                                @change="validate"
                                @place_changed="placechange1"
                                class="mt-1 location-search"
                                :options="{
                                    fields: [
                                        'geometry',
                                        'formatted_address',
                                        'address_components',
                                    ],
                                }"
                            ></GmapAutocomplete>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" class="mt-1">
                        <c-input
                            type="text"
                            inputId="state"
                            readonly
                            v-model="office.address.state"
                            labelText="State"
                        />
                    </b-col>
                </b-row>
                <div class="streetmargintop">
                    <b-row class="mb-4">
                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="City"
                            >
                                <c-input
                                    type="text"
                                    inputId="city"
                                    readonly
                                    v-model="office.address.city"
                                    labelText="City *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Country"
                            >
                                <c-input
                                    type="text"
                                    inputId="state"
                                    readonly
                                    v-model="office.address.country"
                                    labelText="Country *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" class="mt-0 mt-md-3">
                            <ValidationProvider
                                rules="required|digits:6"
                                v-slot="{ errors }"
                                name="zipcode"
                            >
                                <c-input
                                    inputType="number"
                                    inputId="zipcode"
                                    v-model="office.address.zip"
                                    labelText="Zipcode *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <slot name="footer-button" :data="office"> </slot>
                </div>
            </b-card>
        </div>
    </ValidationObserver>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import csc from "country-state-city";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import locationMixins from "@/mixins/addressLocation";

export default {
    name: "AddressStepper",
    mixins: [locationMixins],
    data() {
        return {
            countries: [],
            states: [],
            cities: [],
            office: {
                address: {
                    country: "",
                    area: "",
                    state: "",
                    city: "",
                    street1: "",
                    street2: "",
                    zip: "",
                    houseNumber: "",
                    location: {
                        coordinates: [0, 0],
                    },
                },
            },
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        cInput,
    },
    methods: {
        placechange1(e) {
            this.placechange(e);
            this.$emit("place_changed", e);
            let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
            if (mapdata) {
                this.office.address.country = mapdata.data.Country;
                this.office.address.city = mapdata.data.City;
                this.office.address.state = mapdata.data.State;
                this.office.address.area = mapdata.data.Area
                    ? mapdata.data.Area
                    : "";
                this.office.address.zip = mapdata.data.zip
                    ? mapdata.data.zip
                    : "";
                this.office.address.location = {
                    coordinates: [mapdata.Lng, mapdata.Lat],
                };
            }
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
        async setCountry() {
            this.countries = await csc.getAllCountries();
        },
        async setState(id) {
            this.states = await csc.getStatesOfCountry(id);
        },
        async setCity(id) {
            this.cities = await csc.getCitiesOfState(id);
        },
    },
    mounted() {
        this.setCountry();
    },
};
</script>
<style scoped>
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}
[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: var(--primary);
    color: white;
}
.statemargintop {
    margin-top: 0 !important;
}
.streetmargintop {
    margin-top: 0 !important;
}

@media (min-width: 768px) {
    .statemargintop {
        margin-top: -15px !important;
    }
    .streetmargintop {
        margin-top: -8px !important;
    }
}
</style>
<style>
.vue-tel-input {
    border-radius: 0px !important;
    height: 39px !important;
    border: 1px solid #dee2e6 !important;
}
.custm-err {
    color: red;
}
</style>
